import * as dayjs from 'dayjs'
import 'dayjs/locale/es'
import * as isBetween from 'dayjs/plugin/isBetween'

export const getCurrentTime = () => {
  return new Date()
}

export const formatDateToHourAndDate = formatDays => {
  return Object.keys(formatDays).map(value => ({
    date: dayjs(formatDays[value].startDate).toDate(),
    startHour: `${dayjs(formatDays[value].startDate).format('HH:mm')}`,
    finishHour: `${dayjs(formatDays[value].finishDate).format('HH:mm')}`,
    showSelects: false,
    isInitialDate: false,
  }))
}

export const formatDateServiceViewMapper = (startDate: Date | string) => {
  return dayjs(startDate)
    .locale('es')
    .format('DD MMMM')
}

export const formatIntervalServiceViewMapperDetails = (startDate: Date | string, finishDate: Date | string) => {
  return `${dayjs(startDate).format('HH:mm')}h - ${dayjs(finishDate).format('HH:mm')}h`
}

export const isPastDate = (date: string) => dayjs().isAfter(dayjs(date))

export const isToday = date =>
  dayjs(date).date() === dayjs().date() &&
  dayjs(date).month() === dayjs().month() &&
  dayjs(date).year() === dayjs().year()

export const isLast7Day = date =>
  dayjs(date).date() === dayjs().date() &&
  dayjs(date).month() === dayjs().month() &&
  dayjs(date).year() === dayjs().year()

export const isLast30Day = date =>
  dayjs(date).date() === dayjs().date() &&
  dayjs(date).month() === dayjs().month() &&
  dayjs(date).year() === dayjs().year()

export const formatDateWithSlashes = (date: Date | string) => dayjs(date).format('DD/MM/YYYY')

export const formatDateWithHyphens = (date: Date) => dayjs(date).format('YYYY-MM-DD')

export const getHourDifference = (startDate: Date, finishDate: Date) => {
  const start = dayjs(startDate)
  const end = dayjs(finishDate)

  return end.diff(start, 'hour')
}

export const lastLoginFormat = date => {
  const formatDate = dayjs(date, 'YYYY-MM-DD')
  if (isToday(formatDate)) {
    return 'Hoy'
  }
  dayjs.extend(isBetween)
  if (formatDate.isBetween(dayjs().subtract(2, 'day'), dayjs(), 'day')) {
    return 'Ayer'
  }
  if (formatDate.isBetween(dayjs().subtract(7, 'day'), dayjs(), 'day')) {
    return 'Esta semana'
  }
  if (formatDate.isBetween(dayjs().subtract(30, 'day'), dayjs(), 'day')) {
    return 'Este mes'
  }

  return 'Hace más de 1 mes'
}

export const formatToMonthAndYear = date =>
  dayjs(date, 'YYYY-MM-DD')
    .locale('es')
    .format('MMMM YYYY')

export const formatToDateMonthAndYearInSeconds = date =>
  dayjs
    .unix(date)
    .locale('es')
    .format('D MMMM YYYY')

export const isADateBeforeInSeconds = (date, dateBefore) => dayjs.unix(dateBefore).isBefore(dayjs.unix(date), 'date')

export const formatDateToDayHourYear = date =>
  dayjs(date)
    .locale('es')
    .format('D MMMM YYYY ')

export const formatDateAndHourToDate = (date, hour: string) => {
  const splitHour = hour.split(':')
  return dayjs(date)
    .hour(+splitHour[0])
    .minute(+splitHour[1])
}

export const isADateAfter1HourFromNow = date => dayjs(date).isAfter(dayjs().add(1, 'h'))

export const getNumberOfDateOnMonth = () => dayjs().date()

export const addHoursToDate = (date, hours: number) =>
  dayjs(date)
    .add(hours, 'h')
    .toDate()



// WEBPACK FOOTER //
// ./src/utils/dateFormatter.ts